import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { jsx } from 'react/jsx-runtime.js';
import cn from 'classnames';
import { useState } from 'react';
import { SubmenuPopup } from '../ApplicationMenu/SubmenuPopup/SubmenuPopup.js';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/objectWithoutProperties';
import typographyStyles from '../Typography/Typography.module.css.js';

function HeaderSubmenu(_ref) {
  var className = _ref.className,
    submenuClassName = _ref.submenuClassName,
    item = _ref.item;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleOpen = function handleOpen() {
    return setOpen(true);
  };
  var handleClose = function handleClose() {
    return setOpen(false);
  };
  var isDisabled = item.enabled === false;
  return jsx(SubmenuPopup, {
    className: submenuClassName,
    open: open,
    menu: item.submenu,
    onClose: handleClose,
    children: jsx("button", {
      className: cn(typographyStyles.text, className),
      onClick: handleOpen,
      disabled: isDisabled,
      children: item.label
    }, item.id || item.label)
  });
}

export { HeaderSubmenu };
